// extracted by mini-css-extract-plugin
module.exports = {"chat-card-layout":"chatCard_chat-card-layout__e5k46","image":"chatCard_image__nXWEy","counter":"chatCard_counter__ApaP6","last-message":"chatCard_last-message__SDb60"};